<template>
  <v-container id="highlight" class="mt-5 mt-sm-15">
  	<h2 class="font-weight-medium ngPurple--text pt-2">Why Choose Us</h2>
    <v-row class="mt-3">
      <v-col
        cols="12"
        sm="3"
        class="d-none d-sm-block"
      >
        <v-list dense>
          <v-list-item
            v-for="(item, i) in highlights"
            :key="i"
            link
            :class="{'borderRight': currentIndex == i}"
            v-ripple="{ class: `ngPurple--text` }"
            @click="currentIndex = i"
          >
            <v-list-item-content>
              <v-list-item-title
                class="subtitile-1 text-right"
                :class="{'ngPurple--text': currentIndex == i}"
              >
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="12" sm="9">
        <v-hover
          v-slot="{ hover }"
          close-delay="20"
        >
          <v-card
            :elevation="hover ? 4 : 1"
            :min-height="$vuetify.breakpoint.xsOnly ? '420' : ''"
            :class="{ 'on-hover': hover }"
          >
            <v-carousel
              v-model="currentIndex"
              cycle
              delimiter-icon="mdi-circle ngPurple--text"
              hide-delimiter-background
              :hide-delimiters="$vuetify.breakpoint.xsOnly ? false : true"
              :show-arrows="false"
            >
              <v-carousel-item
                v-for="(item,i) in highlights"
                :key="i"
              >
                <v-card-text class="pa-0">
                  <v-img
                    :src="item.image_url"
                    :height="$vuetify.breakpoint.xsOnly ? '240' : '375'"
                  />
                  <h2 class="font-weight-medium pa-3 pb-0 d-block d-sm-none">
                    {{ item.name }}
                  </h2>
                  <p class="pa-3 mb-0">
                    {{ item.description }}
                  </p>
                </v-card-text>
              </v-carousel-item>
            </v-carousel>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Highlight',
  data: () => ({
    currentIndex: 0,
    highlights: [
      {
        name: 'Quality Service',
        image_url: 'https://niagamas-production.sgp1.cdn.digitaloceanspaces.com/images/highlights/highlight1.jpg',
        description: 'We are recognised as the top 10 insurance agency in Brunei annually since our inception. We have also received the Achiever of sum $1,000,000 [One Million] insurance premium sold’ award from Insurans Islam TAIB General Takaful in 2020.'
      },
      {
        name: 'Affordability',
        image_url: 'https://niagamas-production.sgp1.cdn.digitaloceanspaces.com/images/highlights/highlight4.jpg',
        description: 'We provide the most affordable quotation in town by helping customers to evaluate our broad selection of insurance products tailored to their needs.'
      },
      {
        name: 'Free Delivery',
        image_url: 'https://niagamas-production.sgp1.cdn.digitaloceanspaces.com/images/highlights/highlight6.jpg',
        description: 'We offer free door-to-door collection and delivery of blue cards and road tax renewals upon our terms and conditions.'
      },
      {
        name: 'Auto Quotation',
        image_url: 'https://niagamas-production.sgp1.cdn.digitaloceanspaces.com/images/highlights/highlight7.jpg',
        description: 'We provide auto-generated renewal quotations to customers’ phones prior to expiry of motor insurance policies.'
      },
      {
        name: 'Customer-focused',
        image_url: 'https://niagamas-production.sgp1.cdn.digitaloceanspaces.com/images/highlights/highlight5.jpg',
        description: 'Our agents are trained to adopt a customer-focused and needs-based sales practice. Our sales policy is rooted in professionalism, integrity, empathy and negotiation. We also run a 24/7 hotline for emergencies and complaints.'
      },
      {
        name: 'Community Spirit',
        image_url: 'https://niagamas-production.sgp1.cdn.digitaloceanspaces.com/images/highlights/highlight2.jpg',
        description: 'We are deeply committed to our Bruneian community, regularly organizing corporate social responsibility programs such as our Ramadhan charity drive in Tutong District for underprivileged families. We are the only insurance agency in Brunei to host annual customer appreciation dinners, we also frequently organize giveaways and lucky draws for both loyal and new clients.'
      },
    ]
  }),
}
</script>

<style>
.v-carousel__controls__item {
  margin: 0 5px !important;
}
</style>

<style scoped>
.v-list-item:hover:before,
.v-list-item:focus:before {
  background-color: #66447E;
}
.borderRight {
  border-right: 2px solid #66447E !important;
}
.v-card {
  transition: 0.2s ease-out;
}
</style>